var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FormControl as MuiFormControl, InputLabel as MuiInputLabel, FormHelperText as MuiFormHelperText, Select as MuiSelect, MenuItem as MuiMenuItem, } from '@material-ui/core';
var defaultStyles = makeStyles(function () { return ({
    label: function (props) { return ({
        top: (props.value || props.focused) ? '4px' : '-4px',
        left: '6px',
    }); },
    select: {
        paddingLeft: '6px',
        paddingBottom: '4px',
    },
    helperText: {
        marginLeft: '6px',
        marginTop: '2px',
    },
}); });
var formControlStyles = makeStyles(function () { return ({
    root: {
        overflow: 'hidden',
    },
}); });
var labelStyles = makeStyles(function () { return ({
    root: {
        whiteSpace: 'nowrap',
    },
}); });
var selectStyles = makeStyles(function (theme) { return ({
    disabled: function (props) { return ({
        color: props.readOnly && theme.palette.text.primary,
    }); },
    icon: function (props) { return ({
        display: props.disabled || props.readOnly ? 'none' : 'inherit',
    }); },
}); });
// eslint-disable-next-line no-redeclare
function Select(props) {
    var _a = React.useState(false), focused = _a[0], setFocused = _a[1];
    var fullProps = __assign(__assign({}, props), { focused: focused });
    var defaultStyle = defaultStyles(fullProps);
    var formControlStyle = formControlStyles(fullProps);
    var labelStyle = labelStyles(fullProps);
    var selectStyle = selectStyles(fullProps);
    var defaultLabelStyle = {
        root: defaultStyle.label,
    };
    var defaultSelectStyle = {
        root: defaultStyle.select,
        disabled: selectStyle.disabled,
        icon: selectStyle.icon,
    };
    var defaultHelperTextStyle = {
        root: defaultStyle.helperText,
    };
    var helperText = props.helperText, margin = props.margin, options = props.options, children = props.children, selectProps = __rest(props, ["helperText", "margin", "options", "children"]);
    var className = selectProps.className, _b = selectProps.variant, variant = _b === void 0 ? 'standard' : _b, label = selectProps.label, onChange = selectProps.onChange, otherProps = __rest(selectProps, ["className", "variant", "label", "onChange"]);
    var style = otherProps.style, required = otherProps.required, fullWidth = otherProps.fullWidth, error = otherProps.error, color = otherProps.color, classes = otherProps.classes;
    var formProps = {
        style: style,
        required: required,
        fullWidth: fullWidth,
        error: error,
        color: color,
        classes: classes,
    };
    var disabled = props.disabled || props.readOnly;
    var onFocus = function () {
        setFocused(true);
    };
    var onBlur = function () {
        setFocused(false);
    };
    var handleChange = function (event, child) {
        if (onChange) {
            onChange(__assign(__assign({}, event), { target: __assign(__assign({}, event.target), { id: props.id }) }), child);
        }
    };
    if (variant === 'default') {
        return (React.createElement(MuiFormControl, __assign({}, formProps, { margin: margin, variant: "outlined", classes: { root: clsx(className, formControlStyle.root) }, disabled: disabled }),
            React.createElement(MuiInputLabel, { variant: "standard", classes: defaultLabelStyle }, label),
            React.createElement(MuiSelect, __assign({ classes: defaultSelectStyle }, selectProps, { variant: "outlined", onFocus: onFocus, onBlur: onBlur, disabled: disabled, onChange: handleChange }), (options && options.length > 0)
                ? options.map(function (option) { return (React.createElement(MuiMenuItem, { key: option.value, value: option.value, dense: true, disabled: option.disabled }, option.label)); })
                : children),
            React.createElement(MuiFormHelperText, { classes: defaultHelperTextStyle }, helperText)));
    }
    return (React.createElement(MuiFormControl, __assign({}, formProps, { margin: margin, variant: variant, classes: { root: clsx(className, formControlStyle.root) }, disabled: disabled }),
        label && React.createElement(MuiInputLabel, { variant: variant, classes: labelStyle }, label),
        React.createElement(MuiSelect, __assign({ classes: selectStyle }, selectProps, { variant: variant, onFocus: onFocus, onBlur: onBlur, disabled: disabled, onChange: handleChange }), (options && options.length > 0)
            ? options.map(function (option) { return (React.createElement(MuiMenuItem, { key: option.value, value: option.value, dense: true, disabled: option.disabled }, option.label)); })
            : children),
        helperText && React.createElement(MuiFormHelperText, null, helperText)));
}
Select.defaultProps = {
    variant: 'standard',
};
export default Select;
//# sourceMappingURL=Select.js.map